//open items in new tab
document.querySelectorAll('.grid__item a.product-view-more-button').forEach(function(link) {
    link.setAttribute('target', '_blank');
});
//end open in new tab
const pointerScroll = (elem) => {

  let isDrag = false;
  
  const dragStart = () => isDrag = true;
  const dragEnd = () => isDrag = false;
  const drag = (ev) => isDrag && (elem.scrollLeft -= ev.movementX);
  
  elem.addEventListener("pointerdown", dragStart);
  addEventListener("pointerup", dragEnd);
  addEventListener("pointermove", drag);
};

document.querySelectorAll(".collection-list").forEach(pointerScroll);

document.addEventListener("DOMContentLoaded", function() {
  // Select all elements with the class 'card-product-collection-link'
  var collectionLinks = document.querySelectorAll('.card-product-collection-link');

  // Loop through each element
  collectionLinks.forEach(function(link) {
    // Find the child 'a' element
    var anchor = link.querySelector('a');

    // Check if the 'a' element's text content equals 'Available Experts'
    if (anchor && anchor.textContent.trim() === 'Available Experts') {
      // Hide the parent element
      link.style.display = 'none';
    }
    if (anchor && anchor.textContent.trim() === 'All Advisors') {
      // Hide the parent element
      link.style.display = 'none';
    }
  });
});
document.addEventListener("DOMContentLoaded", function() {
  // Select all <a> elements within the .collection-links container
  var collectionLinks = document.querySelectorAll('.collection-links > a');

  // Loop through each <a> element
  collectionLinks.forEach(function(link) {
    // Check if the <a> element's text content equals 'Available Experts'
    if (link.textContent.trim() === 'Available Experts') {
      // Hide the <a> element
      link.style.display = 'none';
    }
  });
});
document.addEventListener("DOMContentLoaded", function() {
  // Select all elements with the class 'card__content'
  var cards = document.querySelectorAll('.card__content');

  // Loop through each card element
  cards.forEach(function(card) {
    // Find the .collection-icon image within the current card
    var icon = card.querySelector('.collection-icon img');

    // Ensure the icon exists and has a non-empty data-gif-src attribute
    if (icon && icon.hasAttribute('data-gif-src') && icon.getAttribute('data-gif-src').trim() !== '') {
      // Get the original GIF source and static image source
      var gifSrc = icon.getAttribute('data-gif-src');
      var staticSrc = icon.getAttribute('src');

      // Add event listener for mouse hover on the parent card
      card.addEventListener('mouseenter', function() {
        // Change the source to the GIF when mouse enters the parent
        icon.setAttribute('src', gifSrc);
      });

      // Add event listener for mouse leave on the parent card
      card.addEventListener('mouseleave', function() {
        // Change the source back to the static image when mouse leaves the parent
        icon.setAttribute('src', staticSrc);
      });
    }
  });
});
//check for darkbg
document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('header');
  const sections = document.querySelectorAll('section > div, .section > div');
  const shopifyHeader = document.getElementById('shopify-section-header');

  function isHeaderOnTopOfAccentSection() {
    let headerRect = header.getBoundingClientRect();
    for (let section of sections) {
      let sectionRect = section.getBoundingClientRect();
      if (sectionRect.top <= headerRect.bottom && sectionRect.bottom >= headerRect.top) {
        return section.classList.contains('color-accent-2');
      }
    }
    return false;
  }

  function checkAndApplyDarkBg() {
    if (isHeaderOnTopOfAccentSection()) {
      header.classList.add('dark-bg');
    } else {
      header.classList.remove('dark-bg');
    }
  }

  // Initial check on load
  checkAndApplyDarkBg();

  // Check on scroll
  window.addEventListener('scroll', () => {
    checkAndApplyDarkBg();
  });

  // Monitor for changes in the class of #shopify-section-header
  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      if (mutation.attributeName === 'class') {
        checkAndApplyDarkBg();
      }
    });
  });

  observer.observe(shopifyHeader, {
    attributes: true
  });
});
document.addEventListener('DOMContentLoaded', function() {
  function applyBackgroundChange() {
    var header = document.querySelector('#shopify-section-header');
    var bodyGradient = document.querySelector('body.gradient');
    var headerHasMenu = document.querySelector('.header--has-menu');

    // Check if the window width is less than 768px and if header has 'menu-open'
    if (window.innerWidth < 768 && header && header.classList.contains('menu-open')) {
      if (bodyGradient) {
        bodyGradient.classList.add('transparent');
        headerHasMenu.style.background = 'transparent';
      }
    } else {
      // Remove the 'transparent' class if conditions are not met
      if (bodyGradient) {
        bodyGradient.classList.remove('transparent');
        headerHasMenu.style.background = '';
      }
    }
  }

  // Run check when the window is resized
  window.addEventListener('resize', applyBackgroundChange);

  // Run check when the menu-open class is dynamically added or removed
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.attributeName === 'class') {
        applyBackgroundChange();  // Re-check when class changes
      }
    });
  });

  // Observe changes to the #shopify-section-header class attribute
  var header = document.querySelector('#shopify-section-header');
  if (header) {
    observer.observe(header, { attributes: true });
  }

  // Initial check when the DOM is ready
  applyBackgroundChange();
});
document.addEventListener("DOMContentLoaded", function () {
  const targetUrl = "https://theboarderline.co/collections/all-advisors";

  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === "childList") {
        const modal = document.querySelector(".ReactModal__Content.ReactModal__Content--after-open");
        if (modal) {
          const continueBtn = modal.querySelector('.product-form__submit.servicify-select-a-time-button[data-servicify="continue-shopping"]');
          if (continueBtn) {
            // Clone the button to remove existing event listeners (if needed)
            const newBtn = continueBtn.cloneNode(true);
            newBtn.addEventListener("click", function (e) {
              e.preventDefault();
              window.location.href = targetUrl;
            });
            continueBtn.replaceWith(newBtn);
            // Stop observing after button is handled
            observer.disconnect();
          }
        }
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});